import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function authServiceReducer(state = initialState.facility, action) {
    switch (action.type) {
        case types.GET_FACILITY_PLACES_SUCCESSFULL: return {
            ...state,places: action.getResponse,
        };

        case types.GET_FACILITY_REQUESTS_SUCCESSFULL: return {
            ...state,requests: action.getResponse,
        };

        case types.GET_EMPLOYEE_LIST_SUCCESSFULL: return {
            ...state,TenantUserContext: action.getResponse,
        };

        case types.GET_FACILITY_ZONEDETAILS_SUCCESSFULL: return {
            ...state,facilityzonedetails: action.getResponse
        };

        case types.GET_EMPLOYEE_LOGIN_LOGO: return {
            ...state,loginlogo: action.getResponse
        };

        case types.GET_TEMPERATURE_WIDGET_SUCCESSFULL: return {
            ...state, TempWidgetDetails: action.getResponse,
        };

        case types.GET_EMPLOYEE_DETAILS: return {
            ...state, EmployeeDetails: action.getResponse,
        };

        case types.GET_EMPLOYEE_TENANT_DETAILS: return {
            ...state, EmployeeTenantDetails: action.getResponse,
        };

        case types.GET_EMPLOYEE_TENANT_ORIGIN: return {
            ...state, EmployeeTenantOrigin: action.getResponse,
        };

        default : return state; 
    }   
}